import { addDays, eachDayOfInterval, format, parse } from "date-fns";
import { groupBy, map, orderBy } from "lodash";
import { errorLog } from "../../../logger";
import { dateFormat } from "../Shared";
export function isDateRangePointWithDate(d) {
    return d.dateRange !== null;
}
export function createDateRangesBetween(startDate, endDate) {
    const startAsDate = parse(startDate, dateFormat, new Date());
    const endAsDate = parse(endDate, dateFormat, new Date());
    // is inclusive of start and end date
    const days = eachDayOfInterval({
        start: startAsDate,
        end: endAsDate,
    });
    // chop of the last day since we don't want to do "endDate -> endDate + 1"
    const mostDays = days.slice(0, -1).map((d) => ({
        startDate: format(startAsDate, dateFormat),
        endDate: format(addDays(d, 1), dateFormat),
    }));
    const firstDay = { startDate: startDate, endDate: startDate };
    return [firstDay, ...mostDays];
}
export function getBalances(dateRangePoints) {
    const pointsWithDates = dateRangePoints.filter(isDateRangePointWithDate);
    const groupedPoints = groupBy(pointsWithDates, (p) => p.dateRange.endDate);
    const singlePointPerDate = map(groupedPoints, (value, key) => [key, sumDateRangePoint(value)]);
    const sorted = orderBy(singlePointPerDate, [(p) => p[0]], ["asc"]);
    return sorted.map((p) => ({
        startDate: p[1].dateRange.startDate,
        endDate: p[1].dateRange.endDate,
        balanceStart: p[1].beginningMarketValue,
        balanceEnd: p[1].endingMarketValue,
        returns: p[1].timeWeightedReturns?.returns ?? 0,
        netGains: p[1].netGains ?? 0,
        fees: p[1].fees,
        netAdditions: p[1].netAdditions ?? 0,
    }));
}
const sumDateRangePoint = (drps) => drps.reduce((prev, curr) => {
    errorLog("sumDateRangePoint", "Combining DateRangePointWithDates, this code is untested");
    return {
        ...prev,
        netGains: (prev.netGains ?? 0) + (curr.netGains ?? 0),
    };
});
//# sourceMappingURL=getAccountGroups.js.map